var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.276 11.0932L11.0373 4.33182L10.0947 3.38915L3.33333 10.1505V11.0932H4.276ZM4.82867 12.4265H2V9.59782L9.62333 1.97449C9.74835 1.84951 9.91789 1.7793 10.0947 1.7793C10.2714 1.7793 10.441 1.84951 10.566 1.97449L12.452 3.86049C12.577 3.98551 12.6472 4.15505 12.6472 4.33182C12.6472 4.5086 12.577 4.67814 12.452 4.80315L4.82867 12.4265ZM2 13.7598H14V15.0932H2V13.7598Z",
    fill: "#16291E",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/editicon.6bda9056541b6aa147fd76d014b5a7de.svg";
export { ForwardRef as ReactComponent };